import { createApp, setup } from '@/setup'

import TheRoot from '@/components/Container/TheRoot'
import partnerStore from '@/store/partner'
import sessionStore from '@/store/session'

import { APP } from '@/config/constants'
import { PET_SESSION_KEY } from '@/config/petConstants'

window._appName = APP.PET.name
window._appGroup = APP.PET.group
const element = document.getElementById('pet')

const props = element.dataset

const app = await setup({
  appInstance: createApp(TheRoot, props),
  appName: window._appName,
})

// Set session key first
app.config.globalProperties.sessionKey = PET_SESSION_KEY
sessionStore.setSessionKey(PET_SESSION_KEY)

// Initialize session store from storage first, then restore partner state
sessionStore.initializeFromStorage()
partnerStore.initializeFromSession()

const { default: Router } = await import('@/Router')

app.use(Router)
app.mount(element)
